import { render, staticRenderFns } from "./attachment-search.vue?vue&type=template&id=46def78c"
import script from "./attachment-search.vue?vue&type=script&lang=js"
export * from "./attachment-search.vue?vue&type=script&lang=js"
import style0 from "./attachment-search.vue?vue&type=style&index=0&id=46def78c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports